import type {PropsWithChildren} from 'react';
import classNames from 'classnames';

import styles from './menu-item-icon.module.css';

type Props = {
    className?: string;
};

export const MenuItemIcon = ({className, children}: PropsWithChildren<Props>) => (
    <span className={classNames(styles.icon, className)}>{children}</span>
);
